export const nationalities_en = [
  {
    alpha2: "AF",
    value: "AFG",
    label: "Afghanistan",
  },
  {
    alpha2: "AX",
    value: "ALA",
    label: "Åland Islands",
  },
  {
    alpha2: "AL",
    value: "ALB",
    label: "Albania",
  },
  {
    alpha2: "DZ",
    value: "DZA",
    label: "Algeria",
  },
  {
    alpha2: "AS",
    value: "ASM",
    label: "American Samoa",
  },
  {
    alpha2: "AD",
    value: "AND",
    label: "Andorra",
  },
  {
    alpha2: "AO",
    value: "AGO",
    label: "Angola",
  },
  {
    alpha2: "AI",
    value: "AIA",
    label: "Anguilla",
  },
  {
    alpha2: "AQ",
    value: "ATA",
    label: "Antarctica",
  },
  {
    alpha2: "AG",
    value: "ATG",
    label: "Antigua and Barbuda",
  },
  {
    alpha2: "AR",
    value: "ARG",
    label: "Argentina",
  },
  {
    alpha2: "AM",
    value: "ARM",
    label: "Armenia",
  },
  {
    alpha2: "AW",
    value: "ABW",
    label: "Aruba",
  },
  {
    alpha2: "AU",
    value: "AUS",
    label: "Australia",
  },
  {
    alpha2: "AT",
    value: "AUT",
    label: "Austria",
  },
  {
    alpha2: "AZ",
    value: "AZE",
    label: "Azerbaijan",
  },
  {
    alpha2: "BS",
    value: "BHS",
    label: "Bahamas",
  },
  {
    alpha2: "BH",
    value: "BHR",
    label: "Bahrain",
  },
  {
    alpha2: "BD",
    value: "BGD",
    label: "Bangladesh",
  },
  {
    alpha2: "BB",
    value: "BRB",
    label: "Barbados",
  },
  {
    alpha2: "BY",
    value: "BLR",
    label: "Belarus",
  },
  {
    alpha2: "BE",
    value: "BEL",
    label: "Belgium",
  },
  {
    alpha2: "BZ",
    value: "BLZ",
    label: "Belize",
  },
  {
    alpha2: "BJ",
    value: "BEN",
    label: "Benin",
  },
  {
    alpha2: "BM",
    value: "BMU",
    label: "Bermuda",
  },
  {
    alpha2: "BT",
    value: "BTN",
    label: "Bhutan",
  },
  {
    alpha2: "BO",
    value: "BOL",
    label: "Bolivia (Plurinational State of)",
  },
  {
    alpha2: "BQ",
    value: "BES",
    label: "Bonaire, Sint Eustatius and Saba",
  },
  {
    alpha2: "BA",
    value: "BIH",
    label: "Bosnia and Herzegovina",
  },
  {
    alpha2: "BW",
    value: "BWA",
    label: "Botswana",
  },
  {
    alpha2: "BV",
    value: "BVT",
    label: "Bouvet Island",
  },
  {
    alpha2: "BR",
    value: "BRA",
    label: "Brazil",
  },
  {
    alpha2: "IO",
    value: "IOT",
    label: "British Indian Ocean Territory",
  },
  {
    alpha2: "BN",
    value: "BRN",
    label: "Brunei Darussalam",
  },
  {
    alpha2: "BG",
    value: "BGR",
    label: "Bulgaria",
  },
  {
    alpha2: "BF",
    value: "BFA",
    label: "Burkina Faso",
  },
  {
    alpha2: "BI",
    value: "BDI",
    label: "Burundi",
  },
  {
    alpha2: "CV",
    value: "CPV",
    label: "Cabo Verde",
  },
  {
    alpha2: "KH",
    value: "KHM",
    label: "Cambodia",
  },
  {
    alpha2: "CM",
    value: "CMR",
    label: "Cameroon",
  },
  {
    alpha2: "CA",
    value: "CAN",
    label: "Canada",
  },
  {
    alpha2: "KY",
    value: "CYM",
    label: "Cayman Islands",
  },
  {
    alpha2: "CF",
    value: "CAF",
    label: "Central African Republic",
  },
  {
    alpha2: "TD",
    value: "TCD",
    label: "Chad",
  },
  {
    alpha2: "CL",
    value: "CHL",
    label: "Chile",
  },
  {
    alpha2: "CN",
    value: "CHN",
    label: "China",
  },
  {
    alpha2: "CX",
    value: "CXR",
    label: "Christmas Island",
  },
  {
    alpha2: "CC",
    value: "CCK",
    label: "Cocos (Keeling) Islands",
  },
  {
    alpha2: "CO",
    value: "COL",
    label: "Colombia",
  },
  {
    alpha2: "KM",
    value: "COM",
    label: "Comoros",
  },
  {
    alpha2: "CG",
    value: "COG",
    label: "Congo",
  },
  {
    alpha2: "CD",
    value: "COD",
    label: "Congo, Democratic Republic of the",
  },
  {
    alpha2: "CK",
    value: "COK",
    label: "Cook Islands",
  },
  {
    alpha2: "CR",
    value: "CRI",
    label: "Costa Rica",
  },
  {
    alpha2: "CI",
    value: "CIV",
    label: "Côte d'Ivoire",
  },
  {
    alpha2: "HR",
    value: "HRV",
    label: "Croatia",
  },
  {
    alpha2: "CU",
    value: "CUB",
    label: "Cuba",
  },
  {
    alpha2: "CW",
    value: "CUW",
    label: "Curaçao",
  },
  {
    alpha2: "CY",
    value: "CYP",
    label: "Cyprus",
  },
  {
    alpha2: "CZ",
    value: "CZE",
    label: "Czechia",
  },
  {
    alpha2: "DK",
    value: "DNK",
    label: "Denmark",
  },
  {
    alpha2: "DJ",
    value: "DJI",
    label: "Djibouti",
  },
  {
    alpha2: "DM",
    value: "DMA",
    label: "Dominica",
  },
  {
    alpha2: "DO",
    value: "DOM",
    label: "Dominican Republic",
  },
  {
    alpha2: "EC",
    value: "ECU",
    label: "Ecuador",
  },
  {
    alpha2: "EG",
    value: "EGY",
    label: "Egypt",
  },
  {
    alpha2: "SV",
    value: "SLV",
    label: "El Salvador",
  },
  {
    alpha2: "GQ",
    value: "GNQ",
    label: "Equatorial Guinea",
  },
  {
    alpha2: "ER",
    value: "ERI",
    label: "Eritrea",
  },
  {
    alpha2: "EE",
    value: "EST",
    label: "Estonia",
  },
  {
    alpha2: "SZ",
    value: "SWZ",
    label: "Eswatini",
  },
  {
    alpha2: "ET",
    value: "ETH",
    label: "Ethiopia",
  },
  {
    alpha2: "FK",
    value: "FLK",
    label: "Falkland Islands (Malvinas)",
  },
  {
    alpha2: "FO",
    value: "FRO",
    label: "Faroe Islands",
  },
  {
    alpha2: "FJ",
    value: "FJI",
    label: "Fiji",
  },
  {
    alpha2: "FI",
    value: "FIN",
    label: "Finland",
  },
  {
    alpha2: "FR",
    value: "FRA",
    label: "France",
  },
  {
    alpha2: "GF",
    value: "GUF",
    label: "French Guiana",
  },
  {
    alpha2: "PF",
    value: "PYF",
    label: "French Polynesia",
  },
  {
    alpha2: "TF",
    value: "ATF",
    label: "French Southern Territories",
  },
  {
    alpha2: "GA",
    value: "GAB",
    label: "Gabon",
  },
  {
    alpha2: "GM",
    value: "GMB",
    label: "Gambia",
  },
  {
    alpha2: "GE",
    value: "GEO",
    label: "Georgia",
  },
  {
    alpha2: "DE",
    value: "DEU",
    label: "Germany",
  },
  {
    alpha2: "GH",
    value: "GHA",
    label: "Ghana",
  },
  {
    alpha2: "GI",
    value: "GIB",
    label: "Gibraltar",
  },
  {
    alpha2: "GR",
    value: "GRC",
    label: "Greece",
  },
  {
    alpha2: "GL",
    value: "GRL",
    label: "Greenland",
  },
  {
    alpha2: "GD",
    value: "GRD",
    label: "Grenada",
  },
  {
    alpha2: "GP",
    value: "GLP",
    label: "Guadeloupe",
  },
  {
    alpha2: "GU",
    value: "GUM",
    label: "Guam",
  },
  {
    alpha2: "GT",
    value: "GTM",
    label: "Guatemala",
  },
  {
    alpha2: "GG",
    value: "GGY",
    label: "Guernsey",
  },
  {
    alpha2: "GN",
    value: "GIN",
    label: "Guinea",
  },
  {
    alpha2: "GW",
    value: "GNB",
    label: "Guinea-Bissau",
  },
  {
    alpha2: "GY",
    value: "GUY",
    label: "Guyana",
  },
  {
    alpha2: "HT",
    value: "HTI",
    label: "Haiti",
  },
  {
    alpha2: "HM",
    value: "HMD",
    label: "Heard Island and McDonald Islands",
  },
  {
    alpha2: "VA",
    value: "VAT",
    label: "Holy See",
  },
  {
    alpha2: "HN",
    value: "HND",
    label: "Honduras",
  },
  {
    alpha2: "HK",
    value: "HKG",
    label: "Hong Kong",
  },
  {
    alpha2: "HU",
    value: "HUN",
    label: "Hungary",
  },
  {
    alpha2: "IS",
    value: "ISL",
    label: "Iceland",
  },
  {
    alpha2: "IN",
    value: "IND",
    label: "India",
  },
  {
    alpha2: "ID",
    value: "IDN",
    label: "Indonesia",
  },
  {
    alpha2: "IR",
    value: "IRN",
    label: "Iran (Islamic Republic of)",
  },
  {
    alpha2: "IQ",
    value: "IRQ",
    label: "Iraq",
  },
  {
    alpha2: "IE",
    value: "IRL",
    label: "Ireland",
  },
  {
    alpha2: "IM",
    value: "IMN",
    label: "Isle of Man",
  },
  {
    alpha2: "IL",
    value: "ISR",
    label: "Israel",
  },
  {
    alpha2: "IT",
    value: "ITA",
    label: "Italy",
  },
  {
    alpha2: "JM",
    value: "JAM",
    label: "Jamaica",
  },
  {
    alpha2: "JP",
    value: "JPN",
    label: "Japan",
  },
  {
    alpha2: "JE",
    value: "JEY",
    label: "Jersey",
  },
  {
    alpha2: "JO",
    value: "JOR",
    label: "Jordan",
  },
  {
    alpha2: "KZ",
    value: "KAZ",
    label: "Kazakhstan",
  },
  {
    alpha2: "KE",
    value: "KEN",
    label: "Kenya",
  },
  {
    alpha2: "KI",
    value: "KIR",
    label: "Kiribati",
  },
  {
    alpha2: "KP",
    value: "PRK",
    label: "Korea (Democratic People's Republic of)",
  },
  {
    alpha2: "KR",
    value: "KOR",
    label: "Korea, Republic of",
  },
  {
    alpha2: "KW",
    value: "KWT",
    label: "Kuwait",
  },
  {
    alpha2: "KG",
    value: "KGZ",
    label: "Kyrgyzstan",
  },
  {
    alpha2: "LA",
    value: "LAO",
    label: "Lao People's Democratic Republic",
  },
  {
    alpha2: "LV",
    value: "LVA",
    label: "Latvia",
  },
  {
    alpha2: "LB",
    value: "LBN",
    label: "Lebanon",
  },
  {
    alpha2: "LS",
    value: "LSO",
    label: "Lesotho",
  },
  {
    alpha2: "LR",
    value: "LBR",
    label: "Liberia",
  },
  {
    alpha2: "LY",
    value: "LBY",
    label: "Libya",
  },
  {
    alpha2: "LI",
    value: "LIE",
    label: "Liechtenstein",
  },
  {
    alpha2: "LT",
    value: "LTU",
    label: "Lithuania",
  },
  {
    alpha2: "LU",
    value: "LUX",
    label: "Luxembourg",
  },
  {
    alpha2: "MO",
    value: "MAC",
    label: "Macao",
  },
  {
    alpha2: "MG",
    value: "MDG",
    label: "Madagascar",
  },
  {
    alpha2: "MW",
    value: "MWI",
    label: "Malawi",
  },
  {
    alpha2: "MY",
    value: "MYS",
    label: "Malaysia",
  },
  {
    alpha2: "MV",
    value: "MDV",
    label: "Maldives",
  },
  {
    alpha2: "ML",
    value: "MLI",
    label: "Mali",
  },
  {
    alpha2: "MT",
    value: "MLT",
    label: "Malta",
  },
  {
    alpha2: "MH",
    value: "MHL",
    label: "Marshall Islands",
  },
  {
    alpha2: "MQ",
    value: "MTQ",
    label: "Martinique",
  },
  {
    alpha2: "MR",
    value: "MRT",
    label: "Mauritania",
  },
  {
    alpha2: "MU",
    value: "MUS",
    label: "Mauritius",
  },
  {
    alpha2: "YT",
    value: "MYT",
    label: "Mayotte",
  },
  {
    alpha2: "MX",
    value: "MEX",
    label: "Mexico",
  },
  {
    alpha2: "FM",
    value: "FSM",
    label: "Micronesia (Federated States of)",
  },
  {
    alpha2: "MD",
    value: "MDA",
    label: "Moldova, Republic of",
  },
  {
    alpha2: "MC",
    value: "MCO",
    label: "Monaco",
  },
  {
    alpha2: "MN",
    value: "MNG",
    label: "Mongolia",
  },
  {
    alpha2: "ME",
    value: "MNE",
    label: "Montenegro",
  },
  {
    alpha2: "MS",
    value: "MSR",
    label: "Montserrat",
  },
  {
    alpha2: "MA",
    value: "MAR",
    label: "Morocco",
  },
  {
    alpha2: "MZ",
    value: "MOZ",
    label: "Mozambique",
  },
  {
    alpha2: "MM",
    value: "MMR",
    label: "Myanmar",
  },
  {
    alpha2: "NA",
    value: "NAM",
    label: "Namibia",
  },
  {
    alpha2: "NR",
    value: "NRU",
    label: "Nauru",
  },
  {
    alpha2: "NP",
    value: "NPL",
    label: "Nepal",
  },
  {
    alpha2: "NL",
    value: "NLD",
    label: "Netherlands",
  },
  {
    alpha2: "NC",
    value: "NCL",
    label: "New Caledonia",
  },
  {
    alpha2: "NZ",
    value: "NZL",
    label: "New Zealand",
  },
  {
    alpha2: "NI",
    value: "NIC",
    label: "Nicaragua",
  },
  {
    alpha2: "NE",
    value: "NER",
    label: "Niger",
  },
  {
    alpha2: "NG",
    value: "NGA",
    label: "Nigeria",
  },
  {
    alpha2: "NU",
    value: "NIU",
    label: "Niue",
  },
  {
    alpha2: "NF",
    value: "NFK",
    label: "Norfolk Island",
  },
  {
    alpha2: "MK",
    value: "MKD",
    label: "North Macedonia",
  },
  {
    alpha2: "MP",
    value: "MNP",
    label: "Northern Mariana Islands",
  },
  {
    alpha2: "NO",
    value: "NOR",
    label: "Norway",
  },
  {
    alpha2: "OM",
    value: "OMN",
    label: "Oman",
  },
  {
    alpha2: "PK",
    value: "PAK",
    label: "Pakistan",
  },
  {
    alpha2: "PW",
    value: "PLW",
    label: "Palau",
  },
  {
    alpha2: "PS",
    value: "PSE",
    label: "Palestine, State of",
  },
  {
    alpha2: "PA",
    value: "PAN",
    label: "Panama",
  },
  {
    alpha2: "PG",
    value: "PNG",
    label: "Papua New Guinea",
  },
  {
    alpha2: "PY",
    value: "PRY",
    label: "Paraguay",
  },
  {
    alpha2: "PE",
    value: "PER",
    label: "Peru",
  },
  {
    alpha2: "PH",
    value: "PHL",
    label: "Philippines",
  },
  {
    alpha2: "PN",
    value: "PCN",
    label: "Pitcairn",
  },
  {
    alpha2: "PL",
    value: "POL",
    label: "Poland",
  },
  {
    alpha2: "PT",
    value: "PRT",
    label: "Portugal",
  },
  {
    alpha2: "PR",
    value: "PRI",
    label: "Puerto Rico",
  },
  {
    alpha2: "QA",
    value: "QAT",
    label: "Qatar",
  },
  {
    alpha2: "RE",
    value: "REU",
    label: "Réunion",
  },
  {
    alpha2: "RO",
    value: "ROU",
    label: "Romania",
  },
  {
    alpha2: "RU",
    value: "RUS",
    label: "Russian Federation",
  },
  {
    alpha2: "RW",
    value: "RWA",
    label: "Rwanda",
  },
  {
    alpha2: "BL",
    value: "BLM",
    label: "Saint Barthélemy",
  },
  {
    alpha2: "SH",
    value: "SHN",
    label: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    alpha2: "KN",
    value: "KNA",
    label: "Saint Kitts and Nevis",
  },
  {
    alpha2: "LC",
    value: "LCA",
    label: "Saint Lucia",
  },
  {
    alpha2: "MF",
    value: "MAF",
    label: "Saint Martin (French part)",
  },
  {
    alpha2: "PM",
    value: "SPM",
    label: "Saint Pierre and Miquelon",
  },
  {
    alpha2: "VC",
    value: "VCT",
    label: "Saint Vincent and the Grenadines",
  },
  {
    alpha2: "WS",
    value: "WSM",
    label: "Samoa",
  },
  {
    alpha2: "SM",
    value: "SMR",
    label: "San Marino",
  },
  {
    alpha2: "ST",
    value: "STP",
    label: "Sao Tome and Principe",
  },
  {
    alpha2: "SA",
    value: "SAU",
    label: "Saudi Arabia",
  },
  {
    alpha2: "SN",
    value: "SEN",
    label: "Senegal",
  },
  {
    alpha2: "RS",
    value: "SRB",
    label: "Serbia",
  },
  {
    alpha2: "SC",
    value: "SYC",
    label: "Seychelles",
  },
  {
    alpha2: "SL",
    value: "SLE",
    label: "Sierra Leone",
  },
  {
    alpha2: "SG",
    value: "SGP",
    label: "Singapore",
  },
  {
    alpha2: "SX",
    value: "SXM",
    label: "Sint Maarten (Dutch part)",
  },
  {
    alpha2: "SK",
    value: "SVK",
    label: "Slovakia",
  },
  {
    alpha2: "SI",
    value: "SVN",
    label: "Slovenia",
  },
  {
    alpha2: "SB",
    value: "SLB",
    label: "Solomon Islands",
  },
  {
    alpha2: "SO",
    value: "SOM",
    label: "Somalia",
  },
  {
    alpha2: "ZA",
    value: "ZAF",
    label: "South Africa",
  },
  {
    alpha2: "GS",
    value: "SGS",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    alpha2: "SS",
    value: "SSD",
    label: "South Sudan",
  },
  {
    alpha2: "ES",
    value: "ESP",
    label: "Spain",
  },
  {
    alpha2: "LK",
    value: "LKA",
    label: "Sri Lanka",
  },
  {
    alpha2: "SD",
    value: "SDN",
    label: "Sudan",
  },
  {
    alpha2: "SR",
    value: "SUR",
    label: "Suriname",
  },
  {
    alpha2: "SJ",
    value: "SJM",
    label: "Svalbard and Jan Mayen",
  },
  {
    alpha2: "SE",
    value: "SWE",
    label: "Sweden",
  },
  {
    alpha2: "CH",
    value: "CHE",
    label: "Switzerland",
  },
  {
    alpha2: "SY",
    value: "SYR",
    label: "Syrian Arab Republic",
  },
  {
    alpha2: "TW",
    value: "TWN",
    label: "Taiwan, Province of China",
  },
  {
    alpha2: "TJ",
    value: "TJK",
    label: "Tajikistan",
  },
  {
    alpha2: "TZ",
    value: "TZA",
    label: "Tanzania, United Republic of",
  },
  {
    alpha2: "TH",
    value: "THA",
    label: "Thailand",
  },
  {
    alpha2: "TL",
    value: "TLS",
    label: "Timor-Leste",
  },
  {
    alpha2: "TG",
    value: "TGO",
    label: "Togo",
  },
  {
    alpha2: "TK",
    value: "TKL",
    label: "Tokelau",
  },
  {
    alpha2: "TO",
    value: "TON",
    label: "Tonga",
  },
  {
    alpha2: "TT",
    value: "TTO",
    label: "Trinidad and Tobago",
  },
  {
    alpha2: "TN",
    value: "TUN",
    label: "Tunisia",
  },
  {
    alpha2: "TR",
    value: "TUR",
    label: "Türkiye",
  },
  {
    alpha2: "TM",
    value: "TKM",
    label: "Turkmenistan",
  },
  {
    alpha2: "TC",
    value: "TCA",
    label: "Turks and Caicos Islands",
  },
  {
    alpha2: "TV",
    value: "TUV",
    label: "Tuvalu",
  },
  {
    alpha2: "UG",
    value: "UGA",
    label: "Uganda",
  },
  {
    alpha2: "UA",
    value: "UKR",
    label: "Ukraine",
  },
  {
    alpha2: "AE",
    value: "ARE",
    label: "United Arab Emirates",
  },
  {
    alpha2: "GB",
    value: "GBR",
    label: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    alpha2: "UM",
    value: "UMI",
    label: "United States Minor Outlying Islands",
  },
  {
    alpha2: "US",
    value: "USA",
    label: "United States of America",
  },
  {
    alpha2: "UY",
    value: "URY",
    label: "Uruguay",
  },
  {
    alpha2: "UZ",
    value: "UZB",
    label: "Uzbekistan",
  },
  {
    alpha2: "VU",
    value: "VUT",
    label: "Vanuatu",
  },
  {
    alpha2: "VE",
    value: "VEN",
    label: "Venezuela (Bolivarian Republic of)",
  },
  {
    alpha2: "VN",
    value: "VNM",
    label: "Viet Nam",
  },
  {
    alpha2: "VG",
    value: "VGB",
    label: "Virgin Islands (British)",
  },
  {
    alpha2: "VI",
    value: "VIR",
    label: "Virgin Islands (U.S.)",
  },
  {
    alpha2: "WF",
    value: "WLF",
    label: "Wallis and Futuna",
  },
  {
    alpha2: "EH",
    value: "ESH",
    label: "Western Sahara",
  },
  {
    alpha2: "YE",
    value: "YEM",
    label: "Yemen",
  },
  {
    alpha2: "ZM",
    value: "ZMB",
    label: "Zambia",
  },
  {
    alpha2: "ZW",
    value: "ZWE",
    label: "Zimbabwe",
  },
];
